export const useFilterOptions = (listRef: any) => {
  const HEAD = {
    title: "AI Filter - Transform photos into extraodinary art styles",
    meta: [
      {
        name: "title",
        content: "AI Filter - Transform photos into extraodinary art styles",
      },
      {
        name: "description",
        content: "Transform photos into extraodinary art styles.",
      },
      {
        name: "keywords",
        content: "",
      },
    ],
  };

  return {
    HEAD,
  };
};
